import React from 'react'

import Field from '../Field'

const DateField = ({ ...rest }) => {
  return <Field type="date" {...rest} />
}

export default DateField
